function konamify() {
  function walk(e) {
    var a, s;
    if (
      (3 == e.nodeType &&
        (e.nodeValue = e.nodeValue.replace(/cosplay/gi, "seksiasu")),
      (a = e.firstChild))
    )
      for (; a; ) (s = a.nextSibling), walk(a), (a = s);
  }

  walk(document.body);
}

export function setup() {
  document.addEventListener("keydown", function (e) {
    var q = (this.kq || []).concat(String.fromCharCode((e || event).keyCode));
    this.kq =
      "&&((%'%'BA".indexOf(q.join("")) != 0 ? []
      : 10 == q.length ? (konamify(), [])
      : q;
  });
}
